export default "__VITE_ASSET__f9d80506__"